import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.feature-sets.ReportAccessView.ReportAccessUserSelect`

export default defineMessages({
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Search users...',
  },
})
